let translateDetectionDisabled = false;

export function setTranslateDetectionDisabled(value: boolean) {
    translateDetectionDisabled = value;
}

export function isPageTranslated(): boolean {
    if (translateDetectionDisabled) return false;
    if (typeof window === "undefined" || typeof document === "undefined") {
        return false;
    }

    const htmlElement = document.documentElement;

    if (htmlElement.hasAttribute("translate") && htmlElement.getAttribute("translate") === "yes") {
        return true;
    }

    if (htmlElement.classList.contains("translated-ltr") || htmlElement.classList.contains("translated-rtl")) {
        return true;
    }

    const fontElements = document.querySelectorAll("font[face]");
    if (fontElements.length > 0) {
        return true;
    }

    const translatedElements = document.querySelectorAll('[class*="translated"]');
    if (translatedElements.length > 0) {
        return true;
    }

    const body = document.body;
    if (body && body.hasAttribute("translate") && body.getAttribute("translate") === "yes") {
        return true;
    }

    const gtxElements = document.querySelectorAll('[class*="gtx-"]');
    if (gtxElements.length > 0) {
        return true;
    }

    const skTransElements = document.querySelectorAll('[class*="skiptranslate"]');
    if (skTransElements.length > 0) {
        return true;
    }

    return false;
}

